import { useState } from 'react'

import type { Form } from 'factorial-form'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { createFieldsForms } from 'modules/custom_resources/components/CustomFields/createFieldsForms'
import ResourceFieldsCollection from 'modules/custom_resources/store/collections/customFields/resourceFields'
import CustomField from 'modules/custom_resources/store/models/customFields/Field'
import folders from 'modules/documents/store/collections/folders'
import { ALL_TYPES } from 'modules/documents/store/models/Folder'
import Employee, { buildEmployee } from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee | null | undefined
  contractVersions: ContractVersions
}
interface ReturnType {
  getValues: () => unknown[]
  forms: Form[]
}

const useCustomFields = ({ employee, contractVersions }: Props): ReturnType => {
  const [customFieldsForms, setCustomFieldForms] = useState<Form[]>([])
  useUnsafeAsyncData(async () => {
    await folders.fetch({
      data: {
        type: ALL_TYPES.sick_leave,
      },
    })

    const sickFolder = folders.sickFolder

    if (!sickFolder) return

    const resourceFieldCollection: any = new ResourceFieldsCollection([], {
      model_ref: 'documents-folder',
      instance_id: sickFolder.attributes.id,
    })
    await resourceFieldCollection.byUsageGroup([CustomField.UsageGroups.documents])

    const employeeModel = employee || buildEmployee()
    const forms = createFieldsForms(resourceFieldCollection, employeeModel, contractVersions)
    setCustomFieldForms(forms)
  }, [employee])

  function getValues(): unknown[] {
    return customFieldsForms.map((form) => form.data()).filter((field) => !!field.value)
  }

  return {
    forms: customFieldsForms,
    getValues,
  }
}

export default useCustomFields
